const ENERGY_LABELS = [
  'Reserved',
  'Deliberate',
  'Effortless',
  'Abundant',
];

export default ENERGY_LABELS;
